<template>
  <div>
    <!-- 总单 -->
    <div
      class="orderList"
      id="orderList"
      @click.stop
      :style="{ height: height + 'px' }"
      :class="[direction == 'btt' ? 'show' : 'rtl', listStatus ? '' : 'hide']"
    >
      <div style="min-height:300px;">
        <header id="el-drawer__title" class="el-drawer__header">
          <span role="heading" title="请选择您的订单">请选择您的订单</span>
          <button
            aria-label="请选择订单"
            type="button"
            class="el-drawer__close-btn"
          >
            <i
              @click="colse"
              class="el-dialog__close el-icon el-icon-close"
            ></i>
          </button>
        </header>
        <el-tabs @tab-click="handleClick" :value="activeName">
          <el-tab-pane
            v-for="item in tabsData"
            :key="item.num"
            :label="item.name"
            :name="item.num"
            class="tabs"
          >
            <div
              class="prover"
              @mouseover="isshow = true"
              @mouseleave="isshow = false"
              v-if="item.num != 2"
            >
              <!-- @mouseover="isshow = true"
                @mouseleave="isshow = false" -->
              <span slot="reference" class="el-dropdown-link">
                {{ placeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <!-- 充值方式 -->
              <div
                v-show="isshow"
                v-if="activeName === '1'"
                class="hoverprover leftprover secelt"
              >
                <span
                  :class="RechargeMethod == '' ? 'active' : ''"
                  class="spanItem rechargeItem"
                  style="display:inline-block;"
                  @click="updataoption(1, 'all')"
                  value=""
                  >全部</span
                >
                <span
                  :class="RechargeMethod == item.paymentId ? 'active' : ''"
                  class="spanItem rechargeItem"
                  style="display:inline-block;"
                  @click="updataoption(1, item)"
                  v-for="(item, i) in payoption"
                  :key="i"
                  :value="item.paymentId"
                  >{{ item.paymentName }}</span
                >
              </div>
              <!-- 遊戲種類 -->
              <div
                v-show="isshow"
                v-if="activeName === '3'"
                class="hoverprover leftprover secelt"
              >
                <span
                  :class="RechargeMethod == '' ? 'active' : ''"
                  class="spanItem"
                  style="display:inline-block;"
                  @click="updataoption(3, 'all')"
                  value=""
                  >全部</span
                >
                <span
                  :class="RechargeMethod == item.platformId ? 'active' : ''"
                  class="spanItem"
                  style="display:inline-block;"
                  @click="updataoption(3, item)"
                  v-for="(item, i) in gameOption"
                  :key="i"
                  :value="item.platformId"
                  >{{ item.name }}</span
                >
              </div>
            </div>
            <div
              class="prover text_right"
              @mouseover="ordershow = true"
              @mouseleave="ordershow = false"
              :class="item.num != 2 ? '' : 'nullData '"
              style="float:right"
            >
              <!--  -->
              <span slot="reference" class="el-dropdown-link ">
                <span>{{ orderStatusName }}</span
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <div v-show="ordershow" class="hoverprover rightprover secelt">
                <span
                  :class="orderStatu.indexOf(item.value) < 0 ? '' : 'active'"
                  class="spanItem"
                  style="display:inline-block;"
                  @click="updatRechargeMethod(item)"
                  v-for="item in orderStatus"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.label }}</span
                >
              </div>
            </div>
            <!-- {{ orderLists.length }} -->
            <div
              class="infinite-list-wrapper content-box"
              id="box"
              ref="box"
              @scroll="load"
              :style="{ height: height - 135 + 'px' }"
              style="overflow:auto;"
            >
              <div
                id="maxbox"
                v-if="orderLists != undefined && orderLists.length > 0"
                ref="maxbox"
              >
                <div
                  class="orderItem"
                  v-for="(option, i) in orderLists"
                  :key="i"
                >
                  <div class="orderNum">
                    {{ option.orderId }}
                    <span
                      v-if="activeName == 3 && option.status == 1"
                      style="float:right;"
                      >{{ option.winLose }}:{{ option.win }}</span
                    ><span
                      v-if="activeName == 3 && option.status == 0"
                      style="float:right;"
                      >未开奖</span
                    >
                  </div>
                  <div class="ItemCont" @click="checkOrder(option)">
                    <span>
                      <img
                        v-if="activeName == '1' || activeName == '2'"
                        class="left"
                        :src="getPath(option)"
                        alt=""
                      />
                    </span>
                    <span v-for="item in orderStatus" :key="item.id">
                      <img
                        class="left"
                        v-if="
                          option.status == item.value &&
                            activeName == '3' &&
                            item.value != ''
                        "
                        :src="
                          option.status == item.value &&
                          activeName == '3' &&
                          item.value != ''
                            ? item.src
                            : moren
                        "
                      />
                    </span>
                    <div class="middle">
                      <span
                        class="name"
                        v-if="[1, 2].includes(parseInt(activeName, 10))"
                        >{{ option.paymentName }}</span
                      >

                      <span class="name" v-if="activeName == 3">{{
                        option.channelName
                      }}</span>
                      <span class="time" v-if="activeName != 3">{{
                        option.createDate
                          | customerDatetime("YYYY-MM-DD HH:mm:ss")
                      }}</span>
                      <span v-if="activeName == 3" class="time">{{
                        option.createTime
                          | customerDatetime("YYYY-MM-DD HH:mm:ss")
                      }}</span>
                    </div>
                    <div class="right">
                      <!-- <span class="prince" v-if="option.paymentId == 1002">{{
                        option.usdtAmount
                      }}</span> -->
                      <span class="prince">{{ option.amount }}</span>
                      <span
                        v-if="option.status == 0 && activeName == 1"
                        class="status"
                        >充值中</span
                      >
                      <span
                        v-if="option.status == 0 && activeName == 2"
                        class="status"
                        >提现中</span
                      >
                      <span
                        v-if="option.status == 0 && activeName == 3"
                        class="status"
                        >未结算</span
                      >
                      <span
                        v-else-if="
                          (option.status == 1 && activeName == 2) ||
                            (option.status == 1 && activeName == 1)
                        "
                        class="status"
                        >已完成</span
                      >
                      <span
                        v-if="option.status == 1 && activeName == 3"
                        class="status"
                        >已结算</span
                      >
                      <span
                        v-if="
                          (option.status == 2 && activeName == 2) ||
                            (option.status == 2 && activeName == 1)
                        "
                        class="status"
                        >失败</span
                      >
                      <span
                        v-if="option.status == 2 && activeName == 3"
                        class="status"
                        >已取消</span
                      >
                      <span
                        v-if="option.status == 3 && activeName == 3"
                        class="status"
                        >无效订单</span
                      >
                    </div>
                    <div
                      v-if="
                        option.ChildrenList != undefined &&
                          option.ChildrenList.length > 0
                      "
                      @click.stop="showchildrenList(option)"
                      class="morelist"
                    >
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </div>

                <p class="noMore" v-if="noMore">没有更多了</p>
              </div>
              <p class="loading" v-if="loading">
                <i class="el-icon-loading" />
              </p>

              <div class="nodata" v-else-if="iserror">
                网络不佳，请上拉或<a @click="getData" href="javascript:void(0)"
                  >刷新</a
                >重试
              </div>
              <div
                class="nodata"
                v-else-if="!loading && orderLists.length <= 0"
              >
                暂无订单
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 子单 -->
    <div
      class="orderList childrenOrder"
      v-show="childrenStatus"
      @click.stop
      :class="[direction == 'btt' ? 'show' : 'rtl', listStatus ? '' : 'hide']"
    >
      <div>
        <header @click="back" id="el-drawer__title" class="el-drawer__header">
          <span role="heading"><i class="el-icon-arrow-left"></i>返回</span>
        </header>
        <div style="height:30px;">
          <!-- -->
          <div class="prover">
            <span slot="reference" class="el-dropdown-link">
              <span
                @mouseover="childrenshow = true"
                @mouseleave="childrenshow = false"
                >全部订单状态</span
              ><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <div v-show="childrenshow" class="hoverprover right secelt">
              <span
                :class="orderStatu.indexOf(item.value) < 0 ? '' : 'active'"
                style="display:inline-block;width:50%;"
                @click="updatRechargeMethod(item)"
                v-for="item in orderStatus"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</span
              >
              <div class="search_btn">
                <el-button @click="getData" type="primary" size="small"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            ChildrenLists.ChildrenList != undefined &&
              ChildrenLists.ChildrenList.length != 0
          "
          style="overflow:auto;"
        >
          <div class="orderItem">
            <div class="orderNum">
              订单号:{{ ChildrenLists.orderId }}
              <div class="tip">总单</div>
            </div>
            <div class="ItemCont" @click="checkOrder(ChildrenLists)">
              <img
                class="left"
                src="@/assets/imgs/icon-comment-active.png"
                alt="订单icon"
              />
              <div class="middle">
                <span class="name">{{ ChildrenLists.paymentName }}</span>
                <span class="time">{{ ChildrenLists.createDate }}</span>
              </div>
              <div class="right">
                <span class="prince">{{ ChildrenLists.amount }}</span>
                <span v-if="ChildrenLists.status == 0" class="status"
                  >进行中</span
                >
                <span v-else-if="ChildrenLists.status == 1" class="status"
                  >已完成</span
                >
                <span v-else-if="ChildrenLists.status == 2" class="status"
                  >失败</span
                >
              </div>
            </div>
          </div>
          <div
            class="orderItem"
            v-for="(option, i) in ChildrenLists.ChildrenList"
            :key="i"
          >
            <div class="orderNum">
              订单号:{{ option.orderNumber }}
              <div class="tip">子单</div>
            </div>
            <div class="ItemCont" @click="checkOrder(option)">
              <img
                class="left"
                src="@/assets/imgs/icon-comment-active.png"
                alt="订单icon"
              />
              <div class="middle">
                <span class="name">{{ option.rechargeType }}</span>
                <span class="time">{{ option.createTime }}</span>
              </div>
              <div class="right">
                <span class="prince">{{ option.rechargeMoney }}</span>
                <span class="status">{{ option.orderStatus }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="nodata" v-else>
          暂无订单
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchOrderList, getGameList } from "../service";
import constant from "../constant";

import { getOrderPath } from "../utils/imgs";

export default {
  name: "order-list",
  components: {},
  props: {
    direction: {
      type: String,
      default: () => {}
    }
  },
  watch: {
    activeName(val, old) {
      if (val != old) {
        this.changetabStatus();
      }
    }
  },
  data() {
    return {
      isshow: false,
      iserror: false,
      ordershow: false,
      childrenshow: false,
      orderStatu: [""], //
      loading: false,
      noMore: false,
      placeName: "全部充值方式",
      orderStatusName: "订单状态",
      orderLists: [],
      orderClear: [],
      gameOption: [],
      Games: [],
      moren: require("src/assets/imgs/moren.png"),
      orderStatus: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "进行中"
        },
        {
          value: "1",
          label: "已完成"
        },
        {
          value: "2",
          label: "失败"
        }
      ],

      tabsData: [
        {
          name: "充值订单",
          num: "1"
        },
        {
          name: "提现订单",
          num: "2"
        },
        {
          name: "游戏注单",
          num: "3"
        }
      ],
      RechargeMethod: "",
      size: 10,
      page: 1,
      scrollTop: 0,
      childrenStatus: false,
      ChildrenLists: { ChildrenList: [] },
      box: null,
      maxbox: null,
      count: 0
    };
  },
  created() {
    // console.log("aaa");
    this.changetabStatus();
    this.getData();
  },
  mounted() {
    // this.getData();
    let that = this;
    this.box = document.querySelector("#box");
    this.maxbox = document.querySelector("#maxbox");
    document.addEventListener("click", function(e) {
      if (e.target.className != "orderList") {
        that.colse();
      }
    });
    // this.getDatas();
    this.$store.dispatch("getRechargeListResult");
    this.$store.dispatch("getGameListResult");
  },
  computed: {
    ...mapState({
      userName: state => state.customerInfo.userName,
      userId: state => state.customerInfo.userId,
      listStatus: state => state.listStatus,
      activeName: state => state.activeName,
      height: state => state.height,
      payoption: state => state.rechargeListResult
    })
  },
  methods: {
    // 获取对应的icon图标
    getPath(item) {
      if (item.iconPath) {
        return item.iconPath;
      } else {
        return require("src/assets/imgs/moren.png");
      }
    },
    getOrderPath,
    getGames() {
      getGameList().then(res => {
        this.gameOption = res.data;
      });
    },
    back() {
      this.childrenStatus = false;
    },
    showchildrenList(item) {
      this.childrenStatus = true;
      this.$store.commit("setState", {
        activeName: constant.skillName.Reflect
      });
      this.changetabStatus();
      this.ChildrenLists = item;
    },
    updataoption(type, item) {
      this.page = 1;
      if (type === 1) {
        if (item === "all") {
          this.RechargeMethod = "";
          this.placeName = "全部";
        } else {
          this.RechargeMethod = item.paymentId;
          this.placeName = item.paymentName;
        }
      }
      if (type === 3) {
        if (item === "all") {
          this.RechargeMethod = "";
          this.placeName = "全部";
        } else {
          this.RechargeMethod = item.platformId;
          this.placeName = item.name;
        }
      }
      this.isshow = false;
      this.orderLists = [];
      this.orderClear = [];
      this.getData();
    },
    updatRechargeMethod(item) {
      this.page = 1;
      this.orderStatu[0] = item.value;
      this.orderStatusName = item.label;
      this.ordershow = false;
      this.orderLists = [];
      this.orderClear = [];
      this.getData();
    },
    clearData() {
      this.loading = true;
      this.noMore = false;
      this.page = 1;
      this.orderLists = [];
      this.orderClear = [];
    },

    getData() {
      if (this.page == 0) {
        this.page++;
      }
      let obj = {
        userId: this.userId,
        queryOrderType: parseInt(this.activeName),
        platformOrderClientStatus:
          this.orderStatu.indexOf("") < 0 ? this.orderStatu.map(Number) : [],
        size: this.size,
        clientType: 2,
        page: this.page
      };
      switch (this.activeName) {
        case constant.skillName.NotReceived:
          obj.rechargeType = this.RechargeMethod
            ? parseInt(this.RechargeMethod)
            : "";
          // this.placeName = "全部充值订单";
          break;
        case constant.skillName.Reflect:
          // obj.withdrewType = this.RechargeMethod
          //   ? parseInt(this.RechargeMethod)
          //   : 0;
          // this.placeName = "全部提现方式";
          break;
        case constant.skillName.Game:
          obj.companyId = this.RechargeMethod
            ? parseInt(this.RechargeMethod)
            : "";
          // this.placeName = "全部游戏产品";
          break;
        default:
          obj.rechargeType = this.RechargeMethod
            ? parseInt(this.RechargeMethod)
            : "";
          this.placeName = "全部充值方式";
          break;
      }
      this.loading = true;
      try {
        searchOrderList(obj)
          .then(res => {
            this.iserror = false;
            this.loading = false;
            this.noMore = false;
            this.count = 0;
            this.orderClear = res.data.content;
            res.data.content.forEach(element => {
              this.orderLists.push(element);
            });
            // switch (this.activeName) {
            //   case constant.skillName.NotReceived:
            //     this.orderLists = res.data.content.platformOrderRechargeList
            //       ? res.data.platformOrderRechargeList
            //       : [];
            //     break;
            //   case constant.skillName.Reflect:
            //     this.orderLists = res.data.content.platformOrderWithdrawsList
            //       ? res.data.platformOrderWithdrawsList
            //       : [];
            //     break;
            //   case constant.skillName.Game:
            //     this.orderLists = res.data.content.platformOrderWithdrawsList
            //       ? res.data.platformOrderWithdrawsList
            //       : [];
            //     break;
            // }
            if (res.data.content.length < this.size) {
              this.noMore = true;
            }
          })
          .catch(() => {
            this.page--;
            this.noMore = false;
            this.count = 0;
            this.iserror = true;
          });
      } catch (error) {
        this.page--;
        this.noMore = false;
        this.count = 0;
        this.iserror = true;
      }
    },
    colse() {
      this.childrenStatus = false;
      this.$emit("dialogHide");
    },
    load() {
      // console.log("gundong");
      this.box = document.querySelector("#box");
      this.maxbox = document.querySelector("#maxbox");
      this.scrollTop =
        this.box.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (
        this.box.clientHeight + this.scrollTop >= this.maxbox.clientHeight ||
        this.scrollTop == 0
      ) {
        this.count++;
        if (!this.noMore && this.count == 1) {
          this.page++;
          this.getData();
        }
      }
    },
    checkOrder(item) {
      this.colse();
      item.activeName = this.activeName;
      switch (this.activeName) {
        case constant.skillName.NotReceived:
          item.headTitle = "【充值订单】";
          break;
        case constant.skillName.Reflect:
          item.headTitle = "【提现订单】";
          break;
        case constant.skillName.Game:
          item.headTitle = "【游戏注单】";
          break;
      }
      item.userName = this.userName;
      var data = {
        item: {
          ...item,
          activeName: this.activeName,
          userName: this.userName,
          headTitle: item.headTitle
        },
        orderList: item
      };
      // console.log("============");
      // console.log(data.item);
      // console.log(this.orderClear);
      // console.log("============");
      this.$emit("checkOrder", data);
    },
    changetabStatus() {
      this.orderStatusName = "订单状态";
      switch (this.activeName) {
        case constant.skillName.NotReceived:
          this.placeName = "全部充值方式";
          this.orderStatus = [
            {
              value: "",
              label: "全部"
            },
            {
              value: "0",
              label: "充值中"
            },
            {
              value: "1",
              label: "已完成"
            },
            {
              value: "2",
              label: "失败"
            }
          ];

          this.orderStatu = [""];
          break;
        case constant.skillName.Reflect:
          // this.placeName = "全部提现方式";
          this.orderStatus = [
            {
              value: "",
              label: "全部"
            },
            {
              value: "0",
              label: "提现中"
            },
            {
              value: "1",
              label: "已完成"
            },
            {
              value: "2",
              label: "失败"
            }
          ];

          this.orderStatu = [""];
          break;
        case constant.skillName.Game:
          this.orderStatu = [""];
          this.placeName = "全部游戏产品";
          this.orderStatus = [
            {
              id: "1",
              value: "",
              label: "全部"
            },
            {
              id: "2",
              value: "0",
              label: "未结算",
              src: require("src/assets/imgs/quxiao.png")
            },
            {
              id: "3",
              value: "1",
              label: "已结算",
              src: require("src/assets/imgs/success.png")
            },
            {
              id: "4",
              value: "2",
              label: "已取消",
              src: require("src/assets/imgs/shibai.png")
            },
            {
              id: "5",
              value: "3",
              label: "无效订单",
              src: require("src/assets/imgs/wuxiao.png")
            }
          ];
          this.getGames();
          break;
      }
    },
    handleClick(item) {
      this.$store.commit("setState", {
        activeName: item.name
      });
      this.RechargeMethod = [];
      this.changetabStatus();
      this.page = 1;
      this.orderLists = [];
      this.orderClear = [];
      this.getData();
    }
  }
};
</script>
<style scoped lang="less">
.childrenOrder {
  .tip {
    width: 70px;
    height: 30px;
    text-align: center;
    font-size: 15px;
    line-height: 30px;
    background: rgba(250, 205, 145, 1);
    position: absolute;
    top: 5px;
    right: 0;
  }
}
.secelt {
  .active {
    color: var(--button-bg);
  }
}
.secelt {
  .el-button {
    background: var(--button-bg);
    border-color: var(--button-bg);
  }
}
</style>
<style>
.el-tabs__content {
  min-height: 300px;
  overflow: visible !important;
}
.el-tabs__content .el-drawer__header span {
  font-size: 13px;
}
.el-tabs__item {
  padding-left: 20px !important;
  font-size: 13px;
}
</style>
<style lang="less" scoped>
.prover {
  position: relative;
  font-size: 14px;
  height: 20px;
  float: left;
  color: #999;
  .el-dropdown-link {
    cursor: pointer;
    padding: 0 20px;
    height: 20px;
    display: inline-block;
    font-size: 13px;
  }
}
// .nullData {
//   width: 100%;
// }
.text_right {
  text-align: right;
}
.hoverprover {
  position: absolute;
  top: 15px;
  padding: 10px;
  line-height: 1.5;
  height: auto;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  z-index: 2;
  border-radius: 5px;
  overflow: scroll;
  height: 390px;

  padding-bottom: 120px;

  .spanItem {
    margin: 5px auto;
    margin: 5px;
    border-radius: 3px;
    width: 120px;
    text-align: center;
    border: 1px solid #ccc;
    &:hover {
      background: var(--header-bg);
      cursor: pointer;
      color: #fff;
    }
  }
  &::after {
    top: 1px;
    margin-left: -6px;
    border-top-width: 0;
    border-bottom-color: #fff;
  }
}
.leftprover {
  left: -100px;
  width: 480px;
  .spanItem {
    &:hover {
      background: var(--header-bg);
      cursor: pointer;
      color: #fff;
    }
  }
}
.rightprover {
  right: 10px;
  background: #fff;
  width: 120px;
  text-align: center;
  .spanItem {
    margin: 5px auto;
    margin: 5px auto;
    border-radius: 3px;
    width: 100px;
    background: #fff;
    text-align: center;
    border: 1px solid #ccc;
    &:hover {
      background: var(--header-bg);
      cursor: pointer;
      color: #fff;
    }
  }
}
.left {
  left: 0;
}
.right {
  right: 20px;
}
.nodata {
  text-align: center;
  font-size: 15px;
  height: 45px;
  line-height: 45px;
  background: #fff;
  color: #d3dce6;
}
.search_btn {
  text-align: right;
  margin-right: 10px;
}
@keyframes myfirst {
  0% {
    top: 100vh;
  }
  100% {
    top: 25vh;
  }
}
@keyframes two {
  0% {
    top: 25vh;
  }
  100% {
    top: 100vh;
  }
}
@keyframes tree {
  0% {
    right: -50vh;
  }
  100% {
    right: 0;
  }
}
.pc {
  .orderList {
    width: 350px;
    background: #fff;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 60;
    /deep/.el-popover__reference {
      color: #999;
    }
  }
  .content-box {
    clear: both;
    /*滚动条样式*/
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 20px;
      background-color: #c1c1c1;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background-color: #ebebeb;
    }
  }
  .rtl {
    animation: tree 1s forwards;
  }
  .hide {
    animation: two 1s forwards;
  }
  .loading,
  .noMore {
    width: 100%;
    clear: both;
    text-align: center;
    margin-top: 10px;
  }
}
.mobile {
  /deep/.el-tabs__content {
    overflow: auto;
  }
  /deep/.el-drawer__header {
    padding: 0;
    border-bottom: 1px solid #e5e5e5;
  }
  #box {
    height: 48vh;
    clear: both;
  }
  .loading,
  .noMore {
    width: 100%;
    clear: both;
    text-align: center;
    margin-top: 10px;
  }
  .leftprover {
    width: 360px;
    left: 0;
    .spanItem {
      width: 150px;
      padding: 0 5px;
    }
  }
  .hoverprover {
    background: #fff;
  }
  .orderList {
    width: 100vw;
    height: 75vh !important;
    background: #fff;
    position: fixed;
    right: 0;
    top: 100vh;
    z-index: 99999;
    /deep/.el-popover__reference {
      font-size: 14px;
      color: #999;
    }
    .el-drawer__header {
      /deep/span {
        font-size: 14px;
      }
    }
  }
  .hide {
    animation: two 1s forwards;
  }
  .show {
    animation: myfirst 1s forwards;
  }
}
.orderItem {
  // height: 86px;
  position: relative;
  border-bottom: 2px dashed #e5e5e5;
  clear: both;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background: rgba(242, 242, 242, 1);
  }
  .orderNum {
    padding: 10px 35px 0px 10px;
  }
  .ItemCont {
    height: 60px;
    padding: 10px;
    font-size: 14px;
    .left {
      float: left;
      width: 40px;
      height: 40px;
    }
    .middle {
      float: left;
      width: 45%;
      height: 50px;
      position: relative;
      margin-left: 10px;
      .name {
        position: absolute;
        left: 5px;
        top: 5px;
      }
      .time {
        position: absolute;
        left: 5px;
        top: 28px;
        font-size: 12px;
      }
    }
    .right {
      width: 30%;
      float: right;
      height: 50px;
      position: relative;
      .prince {
        position: absolute;
        right: 5px;
        top: 5px;
      }
      .status {
        position: absolute;
        right: 5px;
        top: 28px;
      }
    }
    .morelist {
      position: absolute;
      right: 0px;
      height: 70px;
      line-height: 70px;
      width: 30px;
      text-align: center;
      top: 35px;
      font-size: 20px;
      border-left: 1px solid #fff;
    }
  }
}
</style>
